module.exports = __webpack_public_path__ + "img/bg.78c130d3.png";